import { render, staticRenderFns } from "./MainAccount.vue?vue&type=template&id=cbadc4a8&scoped=true"
import script from "./MainAccount.vue?vue&type=script&lang=js"
export * from "./MainAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbadc4a8",
  null
  
)

export default component.exports